export enum Outline {
  ghost = 'ghost',
  fill = 'fill',
  transparent = 'transparent'
}
